import * as ActionCable from '@rails/actioncable';
import clientInfo from 'common/lib/clientInfo';

/**
 * Actioncable consumer
 * It can create, store, and manage actioncable websocket subscriptions.
 * Requires meta tag `<meta name="action-cable-url" content="wss://example.com/cable">` in DOM.
 *
 * Create:
 *   const subscriptionInst = subscriptions.create(
 *     { channel: 'Admin::MyChannel', <identifier-key>: <identifier-val> },
 *     {
 *       connected: () => {},
 *       disconnected: () => {},
 *       received: (data) => {},
 *     }
 *   );
 *
 * Find:
 *   const subscriptions = consumer.subscriptions.subscriptions;
 *   subscriptionInst = subscriptions[0];
 *
 * Unsubscribe:
 *   subscriptionInst.unsubscribe();
 *
 * Manage all subscription connections:
 *   consumer.connect();
 *   consumer.disconnect();
 *
 */

// TODO: Log depending on CLIENT_INFO.env once rolled out
// Ex:
//   const ENV = clientInfo.get('env');
//   const DEV_ENV = (ENV === 'development' || ENV === 'test' || ENV === 'qa');
ActionCable.logger.enabled = true;

const consumer = ActionCable.createConsumer();
export { consumer };
